export default {
  props: {
    trigger: {
      type: Object,
      required: true
    }
  }
}
